import {memo} from 'react';

import {Box} from '@mui/material';

import './styles';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

const ApplePayFastCheckout = memo(({onClick, disabled = false}: Props) => (
  <Box className="apple-pay-fast-checkout">
    <button
      id="payment-link-v2-applepay-fast-checkout"
      sentry-label="Apple Pay fast checkout button"
      className="apple-pay-fast-checkout__button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Pay with Apple Pay"
    />
  </Box>
));

export default ApplePayFastCheckout;
